import { type Attachment } from 'entities/Attachment/model/Attachment'
import { type IMediaLibraryType } from 'widgets/MediaLibrary/types/types'

export const getMediaLibraryTypeByAttachmentType = (
  attachmentType: Attachment['type']
): IMediaLibraryType => {
  switch (attachmentType) {
    case 'image':
    case 'gif':
    case 'previewGif':
      return 'images'

    case 'video':
      return 'videos'

    case 'audio':
    case 'voice':
      return 'audio'

    case 'attachment':
    case 'vcard':
      return 'files'

    default:
      return 'all'
  }
}
